import api from './api'

const URL = '/api/client'
let service = {}

service.create = function (data) {
  return api.post(`${URL}/create`, data).then(res => res.data).catch(err => {
    return err.response
  })
}

export default service
